import { render, staticRenderFns } from "./Pinned.vue?vue&type=template&id=5d931708&scoped=true&lang=pug"
import script from "./Pinned.vue?vue&type=script&lang=ts"
export * from "./Pinned.vue?vue&type=script&lang=ts"
import style0 from "./Pinned.vue?vue&type=style&index=0&id=5d931708&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d931708",
  null
  
)

export default component.exports